export default __webpack_public_path__ + "static/12-ba7f152fb6b15a7cbf7d5d944f5e5407.jpg";